// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"237":"fde2f408","390":"ef7cbb26","463":"b3291b28","555":"24c12371","600":"12e66a76","950":"e10a4c84"}[chunkId] + ".chunk.css";
};